import {useEffect} from "react";

/**
 * While `active`, shrinks the app root to the visual viewport, so content pinned to the bottom of
 * the app shell sits on top of the on-screen keyboard instead of behind it.
 *
 * Mobile browsers open the keyboard over the page (iOS always, Chrome without
 * `interactive-widget=resizes-content`) and pan the page so the focused input is visible, which
 * would push the header out of view. Matching `#root` to `visualViewport.height` and undoing the
 * pan keeps the whole shell, header included, inside the visible area.
 */
export const useFitToVisualViewport = (active: boolean) => {
  useEffect(() => {
    const vv = window.visualViewport;
    const root = document.getElementById("root");
    if (!active || !vv || !root) return;
    const update = () => {
      root.style.height = `${vv.height}px`;
      if (vv.offsetTop !== 0) window.scrollTo(0, 0);
    };
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      root.style.height = "";
    };
  }, [active]);
};
